import type { CmsSectionData } from './types';
import { defaultCmsSections } from './cms-defaults-data';

export { defaultCmsSections };

export function getDefaultCmsSections(): CmsSectionData[] {
  return defaultCmsSections;
}
